import React, {useContext, useState, useMemo, useRef, useCallback, useEffect} from 'react'
import _, {indexOf} from 'lodash'
import EventBox from './../EventBox'

import moment from 'moment'

import MoreEventBox from './MoreEventBox'
import useCalendarEvents from './../useCalendarEvents'
import EventItem from './EventItem'
import './WeekRow.styles.scss'
import ApMath from '../../../utils/ApMath'
import useViewColor from '../useViewColor'
import {fill} from '../../../utils/ApColor'

const WeekRow = ({
  allEvents,
  week,
  onNavigate = () => {},
  onClickEvent = () => {},
  current_date,
  week_day,
  dayEvents,
  currentDayEvents,
  preDayEvents,
  rowCount,
}) => {
  const refContainer = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const color = useViewColor(useViewColor)

  const getPaddingLeft = useCallback(
    ev => {
      if (
        moment(ev.start)
          .clone()
          .valueOf() <=
        moment(week)
          .clone()
          .valueOf()
      ) {
        return 0
      } else {
        let diff = moment(ev.start)
          .clone()
          .day()
        return diff * (containerWidth / 7)
      }
    },
    [containerWidth, week]
  )

  const getPaddingRight = useCallback(
    ev => {
      if (
        moment(ev.end)
          .clone()
          .valueOf() >=
        moment(week)
          .clone()
          .endOf('week')
          .valueOf()
      ) {
        return 7
      } else {
        let diff =
          6 -
          moment(ev.end)
            .clone()
            .day()
        return diff * (containerWidth / 7) + 7
      }
    },
    [containerWidth, week]
  )

  const getEventTitle = ev => {
    const start_date = moment(ev.start)
    let real_end = moment(ev.end)
    let title = ''
    if (ev.type === 'SystemReservationAction') {
      title = `#${ev?.reservation_uid || ev?.entity_display_name}, ${
        ev.reserved_for
      }, ${start_date.format('MMMM Do')} - ${real_end.format('MMMM Do')}, Items (${ev.items})`
    } else if (ev.type === 'ReservationAction') {
      title = `${ev.entity_display_name}, ${ev.display_name}, ${start_date.format(
        'MMMM Do'
      )} - ${real_end.format('MMMM Do')}`
    } else if (ev.type === 'DefaultAction') {
      title = `${ev.entity_display_name}, ${ev.display_name}, ${start_date.format('MMMM Do')}`
    } else {
      title = `${ev.entity_display_name || ev.display_name}, ${ev.field_name}, ${start_date.format(
        'MMMM Do'
      )}`
    }
    return title
  }

  const prepareValue = data => {
    if (data !== null && data !== undefined) {
      return `${data},`
    } else {
      return ''
    }
  }

  const getShareableEventTitle = ev => {
    const start_date = moment(ev.start)
    let real_end = moment(ev.end)
    let title = ''
    let displayName = ''
    let reservationID = ''
    let e_display_name = prepareValue(ev?.entity_display_name)
    let d_name = prepareValue(ev?.display_name)
    let name_first = prepareValue(ev?.display_name_first)
    let name_second = prepareValue(ev?.display_with_secondary)
    let name_third = prepareValue(ev?.display_name_third)

    if (ev.display_name_first || ev.display_with_secondary || ev.display_name_third) {
      if (!_.isEmpty(ev?.reservation_uid)) {
        reservationID = `#${ev?.reservation_uid},`
      }
      displayName = `${reservationID} ${name_first} ${name_second} ${name_third}`
    } else {
      if (ev.type === 'SystemReservationAction') {
        title = `${reservationID || e_display_name} ${ev.reserved_for}, ${start_date.format(
          'MMMM Do'
        )} - ${real_end.format('MMMM Do')}, Items (${ev.items})`
      } else if (ev.type === 'ReservationAction') {
        title = `${e_display_name} ${d_name} ${start_date.format('MMMM Do')} - ${real_end.format(
          'MMMM Do'
        )}`
      } else if (ev.type === 'DefaultAction') {
        title = `${e_display_name} ${d_name} ${start_date.format('MMMM Do')}`
      } else {
        title = `${e_display_name || d_name} ${ev.field_name}, ${start_date.format('MMMM Do')}`
      }
    }
    if (displayName.length) {
      return displayName.replace(/,\s*$/, '')
    } else {
      return title.replace(/,\s*$/, '')
    }
  }

  return (
    <>
      {currentDayEvents?.map((ev, i) => {
        if (ev?.start) {
          var this_start_date = ev.start.format('MM/DD/YYYY')
          var this_end_date = ev.end.format('MM/DD/YYYY')
          let title = getShareableEventTitle(ev)

          const matchingObj = allEvents.mydata.find(
            obj =>
              moment(obj.start_date, 'MM/DD/YYYY HH:mm:ss').isSame(ev.start, 'day') &&
              moment(obj.end_date, 'MM/DD/YYYY HH:mm:ss').isSame(ev.end, 'day')
          )

          const mergedEvent = {
            ...ev,
            bgColor: matchingObj?.color || ev.bgColor,
          }

          return (
            <>
              {i < rowCount && (
                <div
                  style={{
                    left: getPaddingLeft(ev),
                    right: this_start_date === this_end_date ? getPaddingRight(ev) - 6 : 0,
                    top: 23 * (i + 1),
                    marginTop: 1,
                    marginBottom: 1,
                    cursor: 'pointer',
                    position: 'absolute',
                  }}
                >
                  <EventItem
                    data={ev}
                    eventColor={mergedEvent.bgColor}
                    title={title}
                    onClickEvent={onClickEvent}
                    current_date={current_date}
                    this_start_date={this_start_date}
                    this_end_date={this_end_date}
                    week_day={week_day}
                    preDayEvents={preDayEvents}
                  />
                </div>
              )}
            </>
          )
        } else {
          return (
            <>
              {i < rowCount && (
                <div
                  className=""
                  style={{
                    left: 0,
                    right: 0,
                    top: 23 * (i + 1),
                    marginTop: 1,
                    marginBottom: 1,
                    position: 'absolute',
                  }}
                >
                  <EventItem data={ev} title={''} onClickEvent={onClickEvent} />
                </div>
              )}
            </>
          )
        }
      })}

      {dayEvents.length > rowCount && (
        <>
          {dayEvents.length > rowCount && (
            <div style={{marginTop: 4 + 21 * rowCount}}>
              <MoreEventBox
                className="col"
                data={{...dayEvents, top: 0, right: 64, title: dayEvents.length - rowCount}}
                onNavigate={onNavigate}
                date={current_date}
                events={allEvents}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}

export default WeekRow
